import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Button, Typography } from '@percent/lemonade'

type AuthSuccessTextProps = {
  text: string
  showLoginLink?: boolean
  showLoginButton?: boolean
}

export function AuthSuccessText({ text, showLoginLink = true, showLoginButton = false }: AuthSuccessTextProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goToLogin = () => navigate('/login')

  return (
    <>
      <Typography>{text}</Typography>
      {showLoginLink && (
        <p>
          <Link to="/login">{t('typography.nowLoginHere')}</Link>
        </p>
      )}
      {showLoginButton && (
        <Button stretch size="large" onClick={goToLogin}>
          {t('button.logIn')}
        </Button>
      )}
    </>
  )
}
